import { render, staticRenderFns } from "./VirtualDesktopContent.vue?vue&type=template&id=69370a60&scoped=true"
import script from "./VirtualDesktopContent.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopContent.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopContent.vue?vue&type=style&index=0&id=69370a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69370a60",
  null
  
)

export default component.exports